import axios from 'axios';

const searchUrl = '/api/consumer-address/search';
const formatUrl = '/api/consumer-address/format';

const initialAddress = () => ({
	addressLine1: '',
	addressLine2: '',
	addressLine3: '',
	country: '',
	city: '',
	postalCode: '',
	region: '',
});

const addressSearch = {
	state: () => ({
		addressSearchEnabled: false,
		suggestions: [],
		formattedAddress: initialAddress(),
	}),
	getters: {
		getAddressSuggestions(state) {
			return state.suggestions;
		},
		getFormattedAddress(state) {
			return state.formattedAddress;
		},
	},
	mutations: {
		setSuggestions(state, data) {
			state.suggestions = data;
		},
		setFormattedAddress(state, data) {
			state.formattedAddress = data;
		},
		setPostalCode(state, data) {
			state.formattedAddress = {
				...state.formattedAddress,
				postalCode: data
			};
		}
	},
	actions: {
		updatePostalCode: ({commit}, payload) => {
			commit('setPostalCode', payload);
		},
		resetAddress: ({commit}, payload) => {
			const data = {
				...initialAddress(),
				postalCode: payload
			}
			commit('setFormattedAddress', data);
		},
		fetchAddressSuggestions: async ({ commit }, payload) => {
			try {
				const response = await axios.post(searchUrl, {
					Language: payload.language,
					PartialAddress: payload.query,
					MaxSuggestions: payload.maxSuggestions,
				});

				response.data.responseData.suggestions.push({
					text: payload.notFoundText,
					globalAddressKey: null,
				});

				commit('setSuggestions', response.data.responseData.suggestions);
			} catch (err) {
				console.error(err);
			}
		},
		formatAddress: async ({ commit }, payload) => {
			try {
				const response = await axios.post(formatUrl, {
					Language: payload.language,
					GlobalAddressKey: payload.address.globalAddressKey,
				});

				commit('setFormattedAddress', response.data.responseData.address);
			} catch (err) {
				console.error(err);
			}
		},
	},
};

export default addressSearch;
